import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon, IconButton } from '@material-ui/core';
import { Panel, PanelContent, PanelHeader, PanelMenu } from '@sierralabs/core-ui';
import SiteDialogList from './SiteDialogList';
import SiteRouteList from './SiteRouteList';
const StyledPanel = styled(Panel) `
  .add-icon {
    font-size: 18px;
  }
`;
const SiteNavPanel = () => {
    const [menu, setMenu] = useState('routes');
    const [openDialog, setOpenDialog] = useState(false);
    return (React.createElement(StyledPanel, { className: 'site-nav' },
        React.createElement(PanelHeader, { accessory: React.createElement(IconButton, { size: 'small', onClick: () => setOpenDialog(true) },
                React.createElement(Icon, { className: 'add-icon' }, "add")) },
            React.createElement(PanelMenu, { value: menu, onChange: setMenu })),
        React.createElement(PanelContent, null, (() => {
            switch (menu) {
                case 'routes':
                    return React.createElement(SiteRouteList, { addState: [openDialog, setOpenDialog] });
                case 'dialogs':
                    return React.createElement(SiteDialogList, { addState: [openDialog, setOpenDialog] });
            }
        })())));
};
export default SiteNavPanel;
//# sourceMappingURL=SiteNavPanel.js.map